const RECORDER_ACTIVITY_INTERVAL_MS = 60_000 * 15;

/**
 * Dispatches synthetic mousemove events on a fixed interval so the LogRocket
 * session stays alive while the headless recorder runs.  LogRocket's idle
 * timeout fires after ~30 min of no user input; the recorder never produces
 * real mouse events, so we simulate movement every 15 min.
 *
 * Exported for unit testing.
 */
export function scheduleRecorderActivity(intervalMs = RECORDER_ACTIVITY_INTERVAL_MS): void {
  setInterval(() => {
    window.dispatchEvent(
      new MouseEvent('mousemove', {
        clientX: Math.random() * window.innerWidth,
        clientY: Math.random() * window.innerHeight
      })
    );
  }, intervalMs);
}
